module.exports = __webpack_public_path__ + "media/images/resource-placeholder05-83527815e3e6a3540e626e4984652504.jpg";